import baseUrl from "../config/baseUrl";

const markClientUnknown = async function ({ documentID, token,email,phone }) {
  try {
    const res = await fetch(
      `${baseUrl}/api/update-client-unknown`,
      {
        method: "PUT",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          document_id: documentID, // Parameters in the request body
          email: email,
          phone: phone,
        }),
      }
    );

    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default markClientUnknown;
